module.exports = __webpack_public_path__ + "static/media/62.77cf9b12.png";